import $ from 'jquery'
import _ from 'lodash'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import Button from '../Button'
import styles from './login-window.scss'

class LoginWindow extends Component {
    constructor(props) {
        super(props)

        this.iframe = undefined
        this.iframeURL = undefined
        this.account = { remember: false }
    }

    componentDidMount() {
        this.refreshLoginWindow()
    }

    componentDidUpdate(prevProps) {
        this.refreshLoginWindow(prevProps)
    }

    refreshLoginWindow = (prevProps, hide = false) => {
        // If there is no active server, then do nothing
        if (this.props.server == null || _.isEmpty(this.props.server)) {
            return
        }

        let updateWindow = false

        if (prevProps == null || prevProps.server == null) {
            updateWindow = true
        } else if (prevProps.server.serverId !== this.props.server.serverId) {
            updateWindow = true
        } else if (prevProps.server.sso.url !== this.props.server.sso.url) {
            updateWindow = true
        }

        if (prevProps != null && prevProps.locale !== this.props.locale) {
            updateWindow = true
        }

        if (updateWindow) {
            try {
                this.props.logoutFromSSO($('#sso-frame'), '')

                if (hide) {
                    this.props.displayLoginWindow(false)
                    this.props.onReady('loading')
                } else {
                    this.loadSingleSignOnFrame()
                }
            } catch (error) {
                console.info(`Could not update SSO iframe: ${error.message}`)
            }
        }
    }

    loadSingleSignOnFrame = () => {
        // Retrieve the SSO iframe
        this.iframe = $('#sso-frame')

        // When the SSO reloads we perform this check
        $('#sso-frame').on('load', (event) => {
            try {
                // let $frameContent = this.iframe.contents()
                this.iframeURL = event.currentTarget.contentWindow.location.href

                if (!this.props.steam.steamStartup) {
                    this.props.updateLaunchOnStartup()
                }

                // Watch for changes in the hash
                $(event.currentTarget.contentWindow).on('hashchange', () => {
                    this.props.checkIfEULA(
                        $(event.currentTarget),
                        event.currentTarget.contentWindow.location.href,
                        styles.eula,
                    )
                })

                // Inform the parent component that the
                // iframe has loaded
                this.props.onReady('ready')

                // If this is a steam startup, update the state
                if (this.props.steam.steamStartup && !this.props.steam.hasLoggedIn) {
                    this.props.updateSteam()
                }

                // Read the query from our iframe
                const query = queryString.parse(event.currentTarget.contentWindow.location.search)

                // If we have a code in the query we can try logging in
                // with code
                if (query.code !== undefined) {
                    this.refreshLoginWindow(null, true)
                    this.loginWithCode(query.code, this.account.remember)
                    return
                }

                // Add the remember me checkbox
                // To make it work with EULA we added the iframeURL
                this.props.addRememberAccountCheckbox(this.iframe, this.iframeURL, this.account)

                // Update the styles of the iframe
                // to match the width of the window
                this.props.updateIframeStyles(this.iframe)

                // Update links
                this.props.correctOpenLinks(this.iframe)
            } catch (error) {
                this.iframeURL = 'external'

                if (error.message.indexOf('Blocked a frame with origin') !== -1) {
                    // CORS error occurred
                    // Create log line
                    console.info(
                        `Requesting SSO status check because of iframe error during login: ${
                            error.message
                        }`,
                    )
                    // Start a status check
                    this.props.ssoStatusCheck(this.props.server)
                } else {
                    console.info(`Encountered an error while loading the SSO: ${error.message}`)
                }
            }
        })
    }

    loginWithCode = (code, rememberAccount) => {
        this.props.ltsLogin(code, rememberAccount).then((user) => {
            if (user.isError) {
                console.info(user.error)

                // Display error message
                this.props.displayError()
                this.props.onReady('ready')

                // Logout from SSO to display login window again
                this.props.logoutFromSSO(this.iframe, this.iframeURL)
                return
            }

            this.props.loginUser(user)
            this.props.displayLoginWindow(false)
        })
    }

    renderThirdPartyLogin() {
        if (!this.props.thirdPartyLogin.enabled) return null

        // Display the login buttons
        this.props.onReady('ready')

        return (
            <div className={styles.third_party_login}>
                <ul className={styles.branded}>
                    {_.map(this.props.thirdPartyLogin.providers, value => (
                        <li key={`login-${value.name}`}>
                            <Button
                                className={styles[value.className]}
                                block
                                target="_blank"
                                href={value.loginUrl}
                            >
                                <i className={`fa ${value.icon}`} /> Login with {value.name}
                            </Button>
                        </li>
                    ))}
                </ul>
            </div>
        )
    }

    render() {
        // If there is no active server, then do nothing
        if (this.props.server == null || _.isEmpty(this.props.server)) {
            return null
        }

        const thirdPartyLogin = this.renderThirdPartyLogin()
        if (thirdPartyLogin) return thirdPartyLogin

        const displayCancelButton = this.props.showCancel ? (
            <Button className="btn" secondary onClick={() => this.props.displayLoginWindow(false)}>
                {this.props.cancelText}
            </Button>
        ) : (
            ''
        )
        return (
            <div>
                <iframe
                    id="sso-frame"
                    title="sso-frame"
                    className={styles.ssoFrame}
                    scrolling="no"
                    src={this.props.ssoUrl}
                />
                {displayCancelButton}
            </div>
        )
    }
}

LoginWindow.propTypes = {
    server: PropTypes.shape({
        serverId: PropTypes.string,
        sso: PropTypes.shape({
            url: PropTypes.string,
        }),
    }),
    locale: PropTypes.string,
    steam: PropTypes.shape({
        hasLoggedIn: PropTypes.bool,
        steamStartup: PropTypes.bool,
    }),
    showCancel: PropTypes.bool,
    thirdPartyLogin: PropTypes.shape({
        enabled: PropTypes.bool,
        providers: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                className: PropTypes.string,
                icon: PropTypes.string,
                loginUrl: PropTypes.string,
            }),
        ),
    }),
    logoutFromSSO: PropTypes.func,
    ssoUrl: PropTypes.string,
    updateIframeStyles: PropTypes.func,
    addRememberAccountCheckbox: PropTypes.func,
    correctOpenLinks: PropTypes.func,
    checkIfEULA: PropTypes.func,
    cancelText: PropTypes.string,
    ltsLogin: PropTypes.func,
    updateLaunchOnStartup: PropTypes.func,
    loginUser: PropTypes.func,
    updateSteam: PropTypes.func,
    displayError: PropTypes.func,
    onReady: PropTypes.func,
    displayLoginWindow: PropTypes.func,
    ssoStatusCheck: PropTypes.func,
}

export default LoginWindow



// WEBPACK FOOTER //
// ./src/components/LoginWindow/login-window.js